import * as React from 'react';
import styled from 'styled-components';
import { SaveButton } from '../../../../scholarships/bse/components/styled';
import Select from '../../../../../../../reusables/Select';
import ReusableInfo from '../../../../../../../reusables/Info';

const Container = styled.div`
  color: #161d1f;
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
  margin: 16px 0px 32px 0px;
  width: 100%;
`;
interface RegisterFormProps {
  optionsPeriod: any[];
  selectedPeriod: any;
  profileInfo: any;
  changePeriod: (period: any) => void;
  onSubmit: () => void;
}

const RegisterForm: React.FC<RegisterFormProps> = (props) => {
  const { optionsPeriod, selectedPeriod, profileInfo, changePeriod, onSubmit } =
    props;

  const { career, prog } = profileInfo.academic;

  return (
    <Container>
      <Select
        label="Selecciona el ciclo que deseas reincorporarte:"
        itemCount={2}
        itemName="name"
        itemValue="value"
        items={optionsPeriod}
        placeholder="Elige el ciclo"
        onChange={changePeriod}
        data-testid="cmp-select-1"
        value={selectedPeriod}
        returnObject
      />
      {career === 'PPE' && !['PPMIN', 'PPIEM'].includes(prog) && (
        <ReusableInfo
          style={{ marginTop: '24px' }}
          text="Te estarías Reincorporando a la Modalidad Semipresencial 50% Virtual, este cambio no implica ninguna afectación en tu malla curricular."
        />
      )}
      <br />
      <SaveButton
        type="button"
        onClick={onSubmit}
        data-testid="btn-register-reincorporation"
      >
        Siguiente
      </SaveButton>
    </Container>
  );
};

export default RegisterForm;
